
import { Button, Flex } from '@chakra-ui/react';
import { useState } from 'react';

import Dialog from '@app/components/common/modals/dialog';
import { TextField, Txt } from '@app/components/common';

import { ActionDialogProps } from './types';

export const DeclineDialog = ({ onAction, selectedTx, actionName }: ActionDialogProps) => {
  const [open, setOpen] = useState(false);
  const [comment, setComment] = useState('');

  return <>
    <Button colorScheme='red' onClick={() => setOpen(true)} >{actionName}</Button>
    <Dialog
      open={open}
      title="Отклонить транзакцию"
      onClose={() => setOpen(false)}
      actions={[
        <Button variant='solid' colorScheme='red' key='cancel' onClick={() => {
          onAction(selectedTx, comment);
          setOpen(false);
        }}>Отклонить</Button>
      ]}
    >
      <Flex>
      <Txt>Отклонить перемещение ХО?</Txt>
      <TextField multiline value={comment} onChange={setComment} id='comment'/>
      </Flex>
    </Dialog>
  </>;
};